import { Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { TrainingCertificatesGateway } from './training-certificates-gateway'
import { TrainingModel } from '../../user-management/models/training-model'
import { TrainingURLS } from '../models/trainingURLS'

@Injectable()
export class NetworkTrainingCertificatesGateway extends TrainingCertificatesGateway {
    constructor(private http: HttpClient) {
        super()
    }

    uploadFile(planyear: number, formData: FormData): Observable<Response> {
        return this.http.post<Response>('../api/UploadCertificate/${planyear}', formData)
    }
    GetNavigationURLs(): Observable<TrainingURLS> {
        return this.http.get<TrainingURLS>('../api/GetNavigationURLs')
    }

    GetUserTrainingDetails(planyear: number): Observable<TrainingModel[]> {
        return this.http.get<TrainingModel[]>(`../api/GetUserTrainingDetailsByUserPRofileName/${planyear}`)
    }
    GetUserTrainingDetailsByPlanyear(planyear: number): Observable<TrainingModel[]> {
        return this.http.get<TrainingModel[]>(`../api/GetUserTrainingDetailsByPlanyear/${planyear}`)
    }
    ShowUploadCertificate(): Observable<boolean> {
        let getURL = '../api/ShowUploadCertificate/'
        return this.http.get<boolean>(getURL)
    }
    LogintoCourseGuide(userName: string, planYear: number): Observable<string> {
        let getURL = '../api/LogintoCourseGuide/' + userName + '/' + planYear
        return this.http.get<string>(getURL)
    }

    GetCurriculumCoursesByPlanyearAndOrgId(planyear: number, orgId: string): Observable<string[]> {
        let getURL = `../api/GetCurriculumCoursesByPlanyear/${planyear}/${orgId}`
        return this.http.get<string[]>(getURL)
    }
}
